function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M291 322v-1h-13v-2h13c0 1 7 1 13-6 9-11 16-38 0-103-21-88-3-166 5-196a10 10 0 00-9-12H97a10 10 0 00-8 4c-3 5-8 14-11 32l-2-1c3-17 8-27 12-32a12 12 0 019-5h203a12 12 0 0111 15c-8 29-26 107-5 194 16 67 8 94-1 105-6 7-12 8-14 8z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M255 358h-14v-2h14s6 0 12-7c9-11 16-37 1-103-21-88-4-166 5-195a10 10 0 00-10-13H61a10 10 0 00-8 5c-4 4-9 14-12 31h-2c4-18 9-28 12-33a12 12 0 0110-5h202a12 12 0 0112 16c-9 29-26 106-5 194 16 66 8 93-1 104-6 8-13 8-14 8z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M218 395v-1H19a12 12 0 01-11-16c7-18 17-61 1-148-19-104-2-141 6-152a12 12 0 019-5h203a12 12 0 0111 15c-8 29-26 107-5 194 16 67 8 94-1 105-6 7-12 8-14 8zM24 75a10 10 0 00-8 4c-8 11-24 48-5 150 15 84 7 128-1 150a10 10 0 001 9 10 10 0 008 4h199c0 1 7 1 13-6 9-11 16-38 0-103-21-88-3-166 5-196a10 10 0 00-9-12z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#6c63ff",
  d: "M192 163H33a8 8 0 110-16h159a8 8 0 010 16z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M192 197H33a8 8 0 110-16h159a8 8 0 010 16zM192 231H33a8 8 0 110-16h159a8 8 0 010 16zM204 265H45a8 8 0 110-16h159a8 8 0 010 16zM204 299H45a8 8 0 110-16h159a8 8 0 010 16z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#6c63ff",
  d: "M108 129H33a8 8 0 110-16h75a8 8 0 010 16z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M99 354c1-7 9-9 15-9a66 66 0 0112 2l12 3 21 6c6 1 13 2 19 0 6-1 11-6 12-12 2-6 0-12-6-14-5-3-11-1-13 4-3 6 0 12 4 17a50 50 0 008 6 31 31 0 0010 5c6 1 13-1 16-7a10 10 0 001-4c0-2-3-2-3 0-1 6-7 8-12 8a24 24 0 01-9-4 53 53 0 01-8-5c-4-4-7-9-5-15 3-4 8-4 12-1s3 9 1 14c-4 4-9 6-15 6-5 1-11-1-17-2l-20-6-12-3a39 39 0 00-12-1c-6 1-13 4-14 11-1 2 2 3 3 1z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#f2f2f2",
  d: "M405 523a458 458 0 005 59v2l184-1a76 76 0 007-9c7-12 10-26 7-35a17 17 0 00-4-6c-7-8-22-7-36 0 13-14 22-30 23-46 1-14-7-25-15-34l-1-1c-7-7-15-14-26-13-12 1-25 11-34 23-10 12-16 25-22 38-7 13-14 27-24 38 14-18 25-37 29-57s1-37-12-47a29 29 0 00-12-5h-2c-11-1-25 3-36 12a84 84 0 00-26 40c-4 15-5 29-5 42z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M526 584h3l4-2 2-2 35-20 36-19a1 1 0 001-2h-1l-5 2-36 19-35 21-1 1-3 2zM480 584h3l1-2 35-49 56-79a1 1 0 001-1l-1-1a2 2 0 00-1 1l-32 45-56 79-4 5-2 2zM432 571l1 11v2h2a168 168 0 01-1-18 220 220 0 014-44 276 276 0 0114-46 317 317 0 0122-46 1 1 0 000-1h-2a2 2 0 000 1l-3 5a317 317 0 00-21 46 275 275 0 00-13 46 217 217 0 00-3 44z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M209 355a2 2 0 011-5 41 41 0 0117 2l53 16a6 6 0 01-3 11l-54-17a41 41 0 01-14-7z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "M428 423a11 11 0 01-5-16l-9-48 23-1 1 46a11 11 0 01-10 19z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#6c63ff",
  d: "M412 398l-24-110a17 17 0 1135-8l23 111a5 5 0 01-3 5l-26 6a4 4 0 01-5-4z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "M373 572h-12l-6-47h18v47z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M352 569h24v14h-39a15 15 0 0115-14z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "M414 571h-12l-6-47h18v47z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M393 568h24v14h-39a15 15 0 0115-14zM358 563a4 4 0 01-1-3l-14-157a5 5 0 014-5l71-2a5 5 0 015 4l-6 157a5 5 0 01-4 4l-14 1a4 4 0 01-5-4l-7-99a1 1 0 00-1-2 1 1 0 00-2 2l-6 100a4 4 0 01-4 4l-12 1a4 4 0 01-4-1z"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 386,
  cy: 219,
  r: 24.6,
  fill: "#ffb8b8"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#6c63ff",
  d: "M339 404a4 4 0 01-1-3c4-28 2-68-1-97a44 44 0 0118-41l13-11a5 5 0 013-1l32 1a4 4 0 013 1l5 11a44 44 0 0118 38l-5 97a5 5 0 01-4 4l-78 3a4 4 0 01-3-2z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "M246 364a11 11 0 0112-11l40-28 11 21-42 20a11 11 0 01-21-2z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#6c63ff",
  d: "M279 369a4 4 0 01-2-2l-16-21a5 5 0 011-6l91-67a18 18 0 0121 28l-91 67a4 4 0 01-3 1 5 5 0 01-1 0z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M387 241c3-4 3-10 1-15s-8-7-12-10l-14-7c-4-3-4-15-5-20l3 1-3-6 9 3-2-5c11 0 17 7 28 6 5 0 11 0 15 3s6 7 7 11c2 10 3 20-2 29s-15 15-24 11z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M252 584h381a1 1 0 000-2H252a1 1 0 000 2z"
});

function SvgRegister(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 634.4 584.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.5c572e1d.svg";
export { ForwardRef as ReactComponent };